/* eslint import/prefer-default-export: "off" */
import _reducer from './reducer';

export const reducer = _reducer;



// WEBPACK FOOTER //
// ./data/Language/index.js